/*
  Shift modular sections · versus
  - <sr-versus-draw data-animate>: the stopping, response and hill charts.
    When one first scrolls into view it draws (CSS transitions on .is-drawn):
    both lines together, at the same rate. Plays once. Without JS, without IntersectionObserver, or
    with reduced motion it never arms, so the final chart shows at once.
  - <sr-versus-film data-loop-end="2.5">: loops only the start of the clip,
    for footage that should not play to its end (e.g. Jumper! 0:00 to 0:02.5).
  Video play / pause and autoplay-in-view come from sr-media.js.
  Custom elements, so they re-initialise on shopify:section:load by themselves.
*/
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('sr-versus-draw')) {
    class SRVersusDraw extends HTMLElement {
      connectedCallback() {
        if (
          !this.hasAttribute('data-animate') ||
          reduceMotion.matches ||
          !('IntersectionObserver' in window) ||
          this.classList.contains('is-drawn')
        ) {
          return;
        }
        this.classList.add('is-armed');
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.play();
            });
          },
          { threshold: 0.5 }
        );
        this.observer.observe(this);
        this.onMotionChange = () => {
          if (reduceMotion.matches) this.finish();
        };
        if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', this.onMotionChange);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.onMotionChange && reduceMotion.removeEventListener) {
          reduceMotion.removeEventListener('change', this.onMotionChange);
        }
      }

      play() {
        if (this.observer) this.observer.disconnect();
        // Two frames so the armed (hidden) state is painted before the transition starts
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => this.classList.add('is-drawn'));
        });
      }

      finish() {
        if (this.observer) this.observer.disconnect();
        this.classList.remove('is-armed');
        this.classList.add('is-drawn');
      }
    }

    customElements.define('sr-versus-draw', SRVersusDraw);
  }

  if (!customElements.get('sr-versus-film')) {
    class SRVersusFilm extends HTMLElement {
      connectedCallback() {
        var end = parseFloat(this.getAttribute('data-loop-end'));
        if (!(end > 0)) return;
        this.loopEnd = end;
        this.videos = Array.prototype.slice.call(this.querySelectorAll('video'));
        this.onTime = (event) => this.check(event.currentTarget);
        this.onPlay = (event) => this.watch(event.currentTarget);
        this.videos.forEach((video) => {
          video.addEventListener('timeupdate', this.onTime);
          video.addEventListener('play', this.onPlay);
          if (!video.paused) this.watch(video);
        });
      }

      disconnectedCallback() {
        (this.videos || []).forEach((video) => {
          video.removeEventListener('timeupdate', this.onTime);
          video.removeEventListener('play', this.onPlay);
          video.srVersusWatching = false;
        });
      }

      check(video) {
        if (video.currentTime >= this.loopEnd) video.currentTime = 0;
      }

      // Frame-accurate check where supported; timeupdate (about 4 per second) covers the rest
      watch(video) {
        if (!('requestVideoFrameCallback' in video) || video.srVersusWatching) return;
        video.srVersusWatching = true;
        var step = (now, meta) => {
          if (!this.isConnected || video.paused) {
            video.srVersusWatching = false;
            return;
          }
          if (meta && meta.mediaTime >= this.loopEnd) video.currentTime = 0;
          video.requestVideoFrameCallback(step);
        };
        video.requestVideoFrameCallback(step);
      }
    }

    customElements.define('sr-versus-film', SRVersusFilm);
  }
})();
